const theme = {
  textColor: "white",
  backgroundColor: "#000008",
};

export default theme;
